import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Phone, MessageCircle, Check, Info } from 'lucide-react';
import { villaData } from '../data/mockData';
import { Link } from 'react-router-dom';

export const PricingPage = () => {
  const handleWhatsApp = () => {
    window.open(`https://wa.me/${villaData.whatsapp.replace(/[^0-9]/g, '')}?text=Salam, qiymətlər haqqında məlumat almaq istəyirəm`, '_blank');
  };
  
  const pricingFeatures = [
    'Bütün imkanlar daxildir',
    'Qızdırılan hovuz',
    'Pulsuz parkinq',
    'Mətbəx ləvazimatları',
    'Karaoke və əyləncə',
    'Geniş meyvə bağı'
  ];
  
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Qiymətlər
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Şaffaf və ədalətli qiymətlərlə ideal tətil
          </p>
        </div>
        
        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12">
          {/* Weekday Pricing */}
          <Card className="border-2 border-green-200 shadow-xl hover:shadow-2xl transition-all duration-300">
            <CardContent className="p-8">
              <div className="text-center mb-6">
                <div className="inline-block px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-medium mb-4">
                  Həftə İçi
                </div>
                <div className="mb-2">
                  <span className="text-5xl font-bold text-green-700">{villaData.pricing.weekday}</span>
                  <span className="text-2xl text-gray-600 ml-2">₼</span>
                </div>
                <p className="text-gray-600">gecəlik</p>
              </div>
              
              <ul className="space-y-3 mb-6">
                {pricingFeatures.map((feature, index) => (
                  <li key={index} className="flex items-center space-x-3">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <p className="text-sm text-gray-600 mb-4">
                <Info className="w-4 h-4 inline mr-1" />
                Bazar ertəsi - Cümə axamı
              </p>
              
              <Button onClick={handleWhatsApp} className="w-full bg-green-600 hover:bg-green-700 text-white">
                <MessageCircle className="w-4 h-4 mr-2" />
                Rezervasiya Et
              </Button>
            </CardContent>
          </Card>
          
          {/* Weekend Pricing */}
          <Card className="border-2 border-blue-200 shadow-xl hover:shadow-2xl transition-all duration-300 relative">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-medium">
                Məşhur
              </span>
            </div>
            <CardContent className="p-8">
              <div className="text-center mb-6">
                <div className="inline-block px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium mb-4">
                  Həftə Sonu
                </div>
                <div className="mb-2">
                  <span className="text-5xl font-bold text-blue-700">{villaData.pricing.weekend}</span>
                  <span className="text-2xl text-gray-600 ml-2">₼</span>
                </div>
                <p className="text-gray-600">gecəlik</p>
              </div>
              
              <ul className="space-y-3 mb-6">
                {pricingFeatures.map((feature, index) => (
                  <li key={index} className="flex items-center space-x-3">
                    <Check className="w-5 h-5 text-blue-600 flex-shrink-0" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <p className="text-sm text-gray-600 mb-4">
                <Info className="w-4 h-4 inline mr-1" />
                Cümə - Bazar günü
              </p>
              
              <Button onClick={handleWhatsApp} className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                <MessageCircle className="w-4 h-4 mr-2" />
                Rezervasiya Et
              </Button>
            </CardContent>
          </Card>
        </div>
        
        {/* Discount Info */}
        <div className="bg-gradient-to-br from-green-600 to-blue-600 rounded-2xl p-8 text-center text-white mb-12">
          <h2 className="text-2xl font-bold mb-2">Xüsusi Endirim!</h2>
          <p className="text-xl text-green-50">{villaData.pricing.discount}</p>
        </div>
        
        {/* Additional Info */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <Card className="border border-gray-200">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Check className="w-6 h-6 text-green-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Giriş Vaxtı</h3>
              <p className="text-gray-600">14:00-dan sonra</p>
            </CardContent>
          </Card>
          
          <Card className="border border-gray-200">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Check className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Çıxış Vaxtı</h3>
              <p className="text-gray-600">12:00-dək</p>
            </CardContent>
          </Card>
          
          <Card className="border border-gray-200">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Check className="w-6 h-6 text-green-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Minimum Qalma</h3>
              <p className="text-gray-600">1 gecə</p>
            </CardContent>
          </Card>
        </div>
        
        {/* CTA Section */}
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 lg:p-12">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Rezervasiya üçün hazırsınız?
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Daha ətraflı məlumat və mövcudluq üçün bizimlə əlaqə saxlayın
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href={`tel:${villaData.phone}`}>
                <Button size="lg" className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white">
                  <Phone className="w-5 h-5 mr-2" />
                  Zəng Et
                </Button>
              </a>
              <Link to="/contact">
                <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-green-600 text-green-600 hover:bg-green-50">
                  Əlaqə Formu
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};